<!-- Wrapper -->
<div class="wrapper">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-3">
        <app-sidebar></app-sidebar>
      </div>
      <div class="col-lg-9">
        <router-outlet></router-outlet>

      </div>
    </div>
  </div>
</div>

<!-- <script src="../js/jquery.js"></script>
    <script src="../js/popper.js"></script>
    <script src="../js/bootstrap.js"></script> -->
